import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import arrowNext from '../../assets/images/arrow-next.png';

export const section = css`
  margin-bottom: 31px;

  @media (min-width: ${breakpoints.lg.up}) {
    margin-bottom: 0;
  }
`;

export const quote = css`
  display: block;
  margin: 0 auto 30px;
`;

export const img = css`
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
  border-radius: 8px;
  margin: 0 auto 30px;
`;

export const line = css`
  font-size: 20px;
  margin: 0 auto 30px;
  font-family: ${fontFamily.fredoka};
  max-width: 900px;
`;

export const author = css`
  font-family: ${fontFamily.fredoka};
  margin: 0;
  font-size: 30px;
`;

export const star = css`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin: 0 3px;
  }
`;

export const carousel = css`
  .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 43px;
    height: 79px;
    color: transparent;
    background: url(${arrowNext}) no-repeat top center/cover;

    &.slick-next {
      right: 0;
      transform: translateY(-50%) rotate(180deg);
    }
  }

  .slick-dots {
    margin: 20px 0 0;
    padding: 0;
    list-style: none;

    li {
      margin: 0 4px;
      display: inline-block;

      button {
        color: transparent;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: ${appColors.gray200};
      }

      &.slick-active {
        button {
          background: ${appColors.orange};
        }
      }
    }
  }
`;
